import { useParams, Link } from "react-router-dom";
import { BiArrowBack, BiLinkExternal } from "react-icons/bi";
import { allProjects } from "../data/projects";

const ProjectDetail = () => {
  const { slug } = useParams();
  const project = allProjects.find((p) => p.slug === slug);

  if (!project) {
    return (
      <div>
        <p className="text-muted">Project not found.</p>
        <Link
          to="/projects"
          className="inline-flex items-center gap-2 text-accent mt-4 text-sm"
        >
          <BiArrowBack /> Back to projects
        </Link>
      </div>
    );
  }

  return (
    <div className="fade-up">
      <Link
        to="/projects"
        className="inline-flex items-center gap-2 text-muted hover:text-white text-sm transition-colors"
      >
        <BiArrowBack /> Back to projects
      </Link>

      {project.image && (
        <div className="mt-8 rounded-lg overflow-hidden border border-border max-w-2xl">
          <img
            src={project.image}
            alt={project.name}
            className="w-full h-auto object-cover object-top"
          />
        </div>
      )}

      <p className="font-mono text-xs text-accent mt-8 uppercase tracking-wide">
        {project.kind === "personal" ? "Personal Project" : "Contract Work"}
      </p>
      <h1 className="text-3xl lg:text-4xl font-bold mt-2">{project.name}</h1>
      <p className="text-muted mt-2">{project.tagline}</p>

      <p className="text-white/90 mt-8 leading-relaxed max-w-xl">
        {project.about}
      </p>

      {project.date && (
        <p className="text-xs font-mono text-muted mt-6">{project.date}</p>
      )}

      {project.link && (
        <a
          href={project.link}
          target="_blank"
          rel="noreferrer"
          className="inline-flex items-center gap-2 mt-8 px-4 py-2.5 rounded-md border border-border text-sm text-white hover:border-accent hover:text-accent transition-colors font-mono"
        >
          {project.linkLabel || "Visit site"} <BiLinkExternal />
        </a>
      )}
    </div>
  );
};

export default ProjectDetail;
